export default __webpack_public_path__ + "static/media/NEVADA.e5396fc0.jpeg";